import PropTypes from 'prop-types';

// For old API response, not GraphQL
const sessionFeePropTypes = PropTypes.shape({
    auto_enroll: PropTypes.bool,
    complimentary: PropTypes.bool,
    description: PropTypes.string,
    end_date: PropTypes.string,
    id: PropTypes.string,
    locale: PropTypes.string,
    price: PropTypes.number,
    product_code: PropTypes.string,
    registrant_class: PropTypes.string,
    start_date: PropTypes.string,
});

export default sessionFeePropTypes;
